import { __awaiter, __generator } from "tslib";
import { app } from "@ekuaibao/whispered";
export var queryDepartmentDataInWeComISV = function (searchKey) { return __awaiter(void 0, void 0, void 0, function () {
    var departmentIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, app.invokeService('@organizationManagement:search:wecom:departments', searchKey)];
            case 1:
                departmentIds = _a.sent();
                return [2, {
                        items: departmentIds.map(function (id) { return ({
                            id: id,
                            name: id,
                            active: true,
                        }); })
                    }];
        }
    });
}); };
